import type { Content, Tree } from "@/app/queries";
import { AsideHead, GHOST_INPUT, locate, type Patch } from "./shared";

/** «Зависимости»: «←» считается от дерева, «→» и «·» — поля документа. */
export function DepsCard({ tree, stepId, content, patch }: { tree: Tree; stepId: string; content: Content; patch: (p: Patch) => void }) {
  const pos = locate(tree, stepId);
  let before: string;
  if (!pos) before = "Открывается после гейта: —";
  else if (pos.prevInTrack) before = `Открывается после гейта: ${pos.track.name} · ${pos.prevInTrack.title}`;
  else if (pos.track.parallel) before = "Параллельный трек — открыт с первого шага";
  else if (pos.prevTrack) before = `Открывается после гейта: ${pos.prevTrack.name} · ${pos.prevTrack.steps[pos.prevTrack.steps.length - 1]!.title}`;
  else before = "Первый шаг маршрута — гейта перед ним нет";
  const set = (key: "opens" | "parallel", value: string) => patch((c) => ({ ...c, deps: { ...c.deps, [key]: value } }));
  return (
    <section className="rounded-md border border-bd bg-card p-3.5">
      <AsideHead title="зависимости" />
      <div className="flex flex-col gap-[9px] text-[12.5px] leading-[1.45] text-ink2">
        <div className="flex items-baseline gap-[9px]">
          <span className="font-mono text-mut">←</span>
          <span className="text-pretty">{before}</span>
        </div>
        <label className="flex items-center gap-[9px]">
          <span className="font-mono text-accdim">→</span>
          <span className="flex-none">Открывает:</span>
          <input aria-label="открывает" value={content.deps.opens} placeholder="трек · шаг" onChange={(e) => set("opens", e.target.value)} className={`${GHOST_INPUT} font-sans text-[12.5px]`} />
        </label>
        <label className="flex items-center gap-[9px]">
          <span className="font-mono text-mut">·</span>
          <span className="flex-none">Параллельно:</span>
          <input aria-label="параллельно" value={content.deps.parallel} placeholder="трек · шаг" onChange={(e) => set("parallel", e.target.value)} className={`${GHOST_INPUT} font-sans text-[12.5px]`} />
        </label>
      </div>
    </section>
  );
}
